import {computed, onMounted, onUnmounted, ref, nextTick} from "ui.vue3";

/*
  Выводит выпадающий список
 */
export default {
  name: 'VfnSelect',
  props: ['modelValue', 'options', 'placeholder', 'searchPlaceholder', 'disabled', 'notAbsolute', 'notAutofocus'],
  emits: ['update:modelValue'],
  
  setup(props, {emit}) {
    
    // Открыт/закрыт
    const opened = ref(false);
    const open = () => {
      localSearch.value = '';
      opened.value = true;
      if (!props.notAutofocus) {
        nextTick(() => {
          if (searchInputEl.value) {
            searchInputEl.value.focus()
          }
        })
      }
      
    }
    const close = () => {
      opened.value = false;
    }
    const toggle = () => {
      opened.value ? close() : open();
    }
    
    // Поиск
    const localSearch = ref('');
    const searchInputEl = ref(null);
    
    // Элементы
    const visibleOptions = computed(() => {
      if (!localSearch.value) {
        return props.options;
      }
      
      const transformText = (text) => {
        if (!text) {
          return '';
        }
        return text.toLowerCase().replace(/[^a-z0-9]/gi, '');
      };
      
      const value = transformText(localSearch.value);
      return props.options.filter(option => transformText(option.name).includes(value) || transformText(option.code).includes(value));
    })
    const onElementClick = (elem) => {
      emit('update:modelValue', (elem === props.modelValue) ? null : elem);
      opened.value = false;
    }
    
    const emptyText = 'No matching options found'
    
    // Внешние клики
    const selectElementRef = ref(null);
    const handleClickOutside = (event) => {
      if (selectElementRef.value && opened.value && !selectElementRef.value.contains(event.target)) {
        close();
      }
    };
    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });
    
    return {
      opened,
      localSearch,
      searchInputEl,
      emptyText,
      onElementClick,
      visibleOptions,
      open,
      close,
      toggle,
      selectElementRef
    };
  },
  template: `
    <div ref="selectElementRef" class="vfn-select" :class="{'vfn-select--opened': opened, 'vfn-select--disabled': disabled, 'vfn-select--not-absolute': notAbsolute}">
      <div class="vfn-select__top">
        <div v-show="opened" class="vfn-select__top-input">
          <img src="/local/templates/new_site_v2/images/parthners_map/search.svg">
          <input v-model="localSearch" type="text" ref="searchInputEl" :placeholder="searchPlaceholder">
        </div>
        <div v-show="!opened" class="vfn-select__top-text" :class="{'vfn-select__top-placeholder': !modelValue}" @click="open">
          {{ modelValue ? modelValue.name : placeholder ? placeholder : '' }}
        </div>
        <button class="vfn-select__top-btn" @click="toggle">
          <img src="/local/templates/new_site_v2/images/parthners_map/chevron.svg">
        </button>
      </div>
      <div v-if="opened" class="vfn-select__bottom">
        <ul v-if="visibleOptions.length" class="vfn-select__list">
          <li v-for="item in visibleOptions" :key="item.code" class="vfn-select__list-item">
            <button class="vfn-select__list-item-btn" @click.stop="onElementClick(item)">
              {{item.name}}
            </button>
          </li>
        </ul>
        <div v-else class="vfn-select__bottom-empty">
          {{emptyText}}
        </div>
      </div>
    </div>
  `,
}
